<template>
  <div v-if="_exibirModalCarregando" id="carregando-info-container">
    <div id="carregando-info-coberta"></div>
    <div id="carregando-info-aviso">
      <p class="fas fa-sync-alt fa-spin"></p>
    </div>
    <div id="carregando-info-mensagem" v-show="temMensagem">
        <span>{{ mensagem }}</span>
    </div>
  </div>
</template>

<script>
import store from '@/store'
export default {
    data() {
      return {
		temMensagem: false,
		mensagem: ''
      }
    },

	computed: {
		_exibirModalCarregando() {
			return store.state.modal_carregando;
		}
	}

};
</script>

<style lang="scss" scoped>
#carregando-info-container {
	display: flex;
	justify-content: center;
	align-items: center;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	cursor: progress;
	z-index: 9999;
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
}
#carregando-info-aviso {
	position: fixed;
	// top: 10%;
	left: calc(50% - 50px);
	font-size: 100px;
	color: #fff;
}
#carregando-info-coberta {
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	background-color: #000;
	opacity: .6;
}

#carregando-info-mensagem {
	position: fixed;
    top: calc(10% + 150px);
    width: 100%;
    text-align: center;
    font-size: 26px;
    color: #fff;
}
</style>